import React from 'react';
import { LoaderWrap } from './LoaderWrap';
import { Circle } from './Circle';

const Loader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <LoaderWrap>
      <svg>
        <Circle
          r='20' cx='50%' cy='50%'
          fill='none'
          strokeWidth='4'
          stroke='#6BBBFA'
        />
      </svg>
    </LoaderWrap>
  );
};

export default Loader;
